import { getLegacyStorageKey } from '../../utils/storage';
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useTdsCommon } from '../../hooks/useTdsCommon'
import { getStateCode, formatDate, formatDecimalAmount, padString, padNumber, stateCodes, reverseStateCodes } from '../../utils/tdsCommon'
import { extractProfileDataApi, downloadCsiFileApi } from '../../utils/tdsFileHandlers'
import TdsProfileSection from '../../components/dashboard/TdsProfileSection'
import { getStorageItem, setStorageItem } from '../../utils/storage'

import { motion } from 'framer-motion'
import { FileText, User, Upload, ArrowLeft, Building2, X, Trash2, Eye, EyeOff } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import TdsDetailsTable from '../../components/dashboard/TdsDetailsTable'
import ChallanDetailsTable from '../../components/dashboard/ChallanDetailsTable'
import TdsSidebar from '../../components/dashboard/TdsSidebar'
import TdsGeneratedFiles from './TdsGeneratedFiles';
import { useError } from '../../contexts/ErrorContext'



const stateOptions = [
    'ANDAMAN AND NICOBAR ISLANDS', 'ANDHRA PRADESH', 'ARUNACHAL PRADESH', 'ASSAM', 'BIHAR', 'CHANDIGARH',
    'CHHATTISGARH', 'DADRA & NAGAR HAVELI AND DAMAN & DIU', 'DELHI', 'GOA', 'GUJARAT', 'HARYANA',
    'HIMACHAL PRADESH', 'JAMMU & KASHMIR', 'JHARKHAND', 'KARNATAKA', 'KERALA', 'LADAKH', 'LAKSHWADEEP',
    'MADHYA PRADESH', 'MAHARASHTRA', 'MANIPUR', 'MEGHALAYA', 'MIZORAM', 'NAGALAND', 'ODISHA',
    'PONDICHERRY', 'PUNJAB', 'RAJASTHAN', 'SIKKIM', 'TAMIL NADU', 'TELANGANA', 'TRIPURA',
    'UTTAR PRADESH', 'UTTARAKHAND', 'WEST BENGAL'
];




// COLLECTION CODES FOR 27EQ
const collectionCodes27EQ_old = [
    { value: 'A', label: 'A - Alcoholic liquor for human consumption' },
    { value: 'B', label: 'B - Collection at source from timber or any other forest produce' },
    { value: 'C', label: 'C - Timber obtained under any mode other than forest lease' },
    { value: 'D', label: 'D - Any other forest product not being timber or tendu leave' },
    { value: 'E', label: 'E - Scrap' },
    { value: 'F', label: 'F - Parking Lot' },
    { value: 'G', label: 'G - Toll Plaza' },
    { value: 'H', label: 'H - Mining and Quarrying' },
    { value: 'I', label: 'I - Tendu leaves' },
    { value: 'J', label: 'J - Collection at source from on sale of certain Minerals' },
    { value: 'K', label: 'K - Collection at source on cash case of Bullion and Jewellery' },
    { value: 'L', label: 'L - Sale of Motor vehicle' },
    { value: 'M', label: 'M - Sale in cash of any goods (other than bullion/jewelry)' },
    { value: 'N', label: 'N - Providing of any services (other than Ch-XVII-B)' },
    { value: 'O', label: 'O - Collection at source for purchase of overseas tour program package' },
    { value: 'P', label: 'P - Collection at source on remittance under LRS from educational loan' },
    { value: 'Q', label: 'Q - Collection at source on remittance under LRS except for education/medical' },
    { value: 'R', label: 'R - Collection at source on sale of goods' },
    { value: 'T', label: 'T - Collection at source on remittance under LRS is for education or medical' },
    { value: 'MA', label: 'MA - Sale of wrist watch (>= 22 April 2025)' },
    { value: 'MB', label: 'MB - Sale of art piece (>= 22 April 2025)' },
    { value: 'MC', label: 'MC - Sale of collectibles (>= 22 April 2025)' },
    { value: 'MD', label: 'MD - Sale of yacht (>= 22 April 2025)' },
    { value: 'ME', label: 'ME - Sale of pair of sunglasses (>= 22 April 2025)' },
    { value: 'MF', label: 'MF - Sale of bag (>= 22 April 2025)' },
    { value: 'MG', label: 'MG - Sale of pair of shoes (>= 22 April 2025)' },
    { value: 'MH', label: 'MH - Sale of sportswear (>= 22 April 2025)' },
    { value: 'MI', label: 'MI - Sale of home theatre system (>= 22 April 2025)' },
    { value: 'MJ', label: 'MJ - Sale of horse (>= 22 April 2025)' }
];

const collectionCodes27EQ_new = [
    { value: '1068', label: '1068 - Alcoholic Liquor for human consumption' },
    { value: '1069', label: '1069 - Tendu Leaves' },
    { value: '1070', label: '1070 - Timber obtained under a forest lease' },
    { value: '1071', label: '1071 - Timber obtained by any mode other than forest lease' },
    { value: '1072', label: '1072 - Any other Forest Produce (not timber/tendu)' },
    { value: '1073', label: '1073 - Scrap Sales' },
    { value: '1074', label: '1074 - Minerals (Coal, Lignite, or Iron Ore)' },
    { value: '1075', label: '1075 - Parking Lot charges / Toll Plaza operations' },
    { value: '1076', label: '1076 - Sale of Luxury Motor Vehicles (above ₹10 Lakhs)' },
    { value: '1077', label: '1077 - LRS Remittance – Overseas Tour Program Package' },
    { value: '1078', label: '1078 - LRS Remittance – Foreign Education / Medical treatments' },
    { value: '1079', label: '1079 - TCS on Sale of general goods (exceeding ₹50 Lakhs)' }
];

// COLLECTEE CODES FOR 27EQ
const collecteeCodes27EQ = [
    { value: '01', label: '01 - Company, other than domestic company' },
    { value: '02', label: '02 - Individual' },
    { value: '03', label: '03 - Hindu Undivided Family' },
    { value: '04', label: '04 - Association of Persons (AOP)' },
    { value: '05', label: '05 - Association of Persons (AOP) (Companies)' },
    { value: '06', label: '06 - Co-operative Society' },
    { value: '07', label: '07 - Firm' },
    { value: '08', label: '08 - Body of individuals' },
    { value: '09', label: '09 - Artificial juridical person' },
    { value: '10', label: '10 - Others' }
]

// MINOR HEAD OPTIONS FOR 27EQ (Based on Annexure 7)
const minorHeadOptions27EQ = [
    { value: '200', label: '200 - TDS payable by taxpayer' },
    { value: '400', label: '400 - TDS regular assessment (Raised by I. T, Dept.)' }
]

const formatMinorHead27EQ = (val) => {
    if (!val) return ''
    const s = String(val).trim()
    if (s === '200' || s === '400') return s
    const lower = s.toLowerCase()
    if (lower.includes('payable') || lower.includes('taxpayer')) return '200'
    if (lower.includes('regular') || lower.includes('assessment')) return '400'
    const match = s.match(/(200|400)/)
    if (match) return match[0]
    return s
}

const Tds27EQCorrectionForm = ({ isMobile, onSidebarStateChange }) => {
    const csiFileInputRef = useRef(null);
    console.log('Rendering Tds27EQCorrectionForm component');
    const navigate = useNavigate()
    const { addError } = useError()
    const [activeSection, setActiveSection] = useState('profile')
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarState, setSidebarState] = useState({
        isOpen: false,
        isExpanded: false,
        keepOpen: false,
        hovered: false
    })

    const {
        profileData,
        challanData,
        tdsData,
        originalTdsData,
        csiFile,
        consoFileContent,
        isValidating,
        showCsiUploadPopup,
        showDownloadPrompt,
        selectedFinancialYear,
        selectedQuarter,
        selectedForm,
        selectedReturnType,
        challanDateRange,
        setProfileData,
        setChallanData,
        setTdsData,
        setOriginalTdsData,
        setCsiFile,
        setConsoFileContent,
        setIsValidating,
        setShowCsiUploadPopup,
        setShowDownloadPrompt,
        setSelectedFinancialYear,
        setSelectedQuarter,
        setSelectedForm,
        setSelectedReturnType,
        handlePrepareReturnFile,
        handleValidateReturn,
        handleSkipDownload,
        handleCancelValidation,
        executeValidation
    } = useTdsCommon({
        formName: 'tds27EQ',
        defaultFormType: '27EQ',
        isCorrection: true,
        generateTdsStatementFile,
        validateDataForReturn,
        onValidationError: (errors) => {
            addError('Please fix the following errors before preparing return:')
            errors.forEach(err => addError(`• ${err}`))
            setSidebarOpen(true)
            setActiveSection('errors')
        }
    });

    const [isProfileEditing, setIsProfileEditing] = useState(true)
    const [downloadPassword, setDownloadPassword] = useState('')
    const [showDownloadPassword, setShowDownloadPassword] = useState(false)
    const [isDownloadingCsi, setIsDownloadingCsi] = useState(false)

    // Profile Pre-fill Automation State
    const [showPrefillPrompt, setShowPrefillPrompt] = useState(false);
    const [prefillPassword, setPrefillPassword] = useState('');
    const [showPrefillPassword, setShowPrefillPassword] = useState(false);
    const [isExtractingProfile, setIsExtractingProfile] = useState(false);

    const [originalProfileData, setOriginalProfileData] = useState(null)
    const [originalChallanData, setOriginalChallanData] = useState([])
    const [batchNumber, setBatchNumber] = useState('1')
    const [consoFhHash, setConsoFhHash] = useState('')

    useEffect(() => {
        (async () => {
            const savedOriginalChallanData = await getStorageItem('tds27EQOriginalChallanData')
            const savedOriginalProfileData = await getStorageItem('tds27EQOriginalProfileData')
            const savedBatchNumber = localStorage.getItem('tds27EQBatchNumber')
            if (savedOriginalChallanData) setOriginalChallanData(savedOriginalChallanData)
            if (savedOriginalProfileData) setOriginalProfileData(savedOriginalProfileData)
            if (savedBatchNumber) setBatchNumber(savedBatchNumber)
        })()
    }, [])

    const handleChallanDataChange = setChallanData;
    const handleTdsDataChange = setTdsData;


    const handleSectionChange = (section) => setActiveSection(section)
    const handleSidebarStateChange = useCallback((state) => setSidebarState(state), [])

    // Sync Section 3
    useEffect(() => {
        if (profileData?.section3?.sameAsAbove && isProfileEditing && profileData?.section2) {
            const newData = { ...profileData }
            if (!newData.section3) newData.section3 = {}

            const s2 = newData.section2
            const s3 = newData.section3
            s3.nameOfPremises = s2.nameOfPremises || ''
            s3.flatNo = s2.flatNo || ''
            s3.areaLocality = s2.areaLocality || ''
            s3.roadStreet = s2.roadStreet || ''
            s3.townCity = s2.townCity || ''
            s3.pinCode = s2.pinCode || ''
            s3.state = s2.state || ''
            s3.email = s2.email || ''

            setProfileData(newData)
            // Cloud sync via updateProfileData)
        }
    }, [profileData?.section2, profileData?.section3?.sameAsAbove, isProfileEditing])

    const handleProfileInputChange = (field, value) => {
        const keys = field.split('.')
        const newData = { ...profileData }
        let current = newData
        for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) current[keys[i]] = {}
            current = current[keys[i]]
        }
        current[keys[keys.length - 1]] = value

        if (field === 'section3.sameAsAbove' && value === true) {
            // Trigger effect will handle sync
        }
        setProfileData(newData)
        // Cloud sync via updateProfileData)
    }

    // Validation function for Prepare Return
    function validateDataForReturn() {
        const errors = []
        if (!tdsData || tdsData.length === 0) errors.push('At least one TCS entry is required')
        if (!challanData || challanData.length === 0) errors.push('At least one Challan entry is required')
        if (!profileData?.section1?.taxDeduction) errors.push('Collector TAN is required in Profile')
        if (!profileData?.section1?.permanentAccountNumber) errors.push('Collector PAN is required in Profile')
        if (!profileData?.section2?.name) errors.push('Collector Name is required in Profile')
        if (!profileData?.section2?.state) errors.push('Collector State is required in Profile')
        if (!profileData?.section3?.name) errors.push('Responsible Person Name is required in Profile')
        if (!profileData?.section1?.typeOfDeduction) errors.push('Collector Type is required in Profile')
        if (!profileData?.section3?.designation) errors.push('Responsible Person Designation is required in Profile')
        if (!profileData?.section3?.flatNo && !profileData?.section3?.nameOfPremises && !profileData?.section3?.roadStreet) {
            errors.push('Responsible Person Address is required in Profile')
        }
        if (!profileData?.section3?.state) errors.push('Responsible Person State is required in Profile')
        if (!profileData?.section3?.pinCode) errors.push('Responsible Person Pincode is required in Profile')
        if (!profileData?.section3?.email) errors.push('Responsible Person Email is required in Profile')
        if (!profileData?.section3?.mobileNo) errors.push('Responsible Person Mobile is required in Profile')
        if (!profileData?.section3?.permanentAccountNumber) errors.push('Responsible Person PAN is required in Profile')

        if (tdsData && tdsData.length > 0) {
            tdsData.forEach((row, index) => {
                if (!row.panOfDeductee) errors.push(`TCS Entry ${index + 1}: PAN of Collectee is required`)
                if (!row.sectionCode) errors.push(`TCS Entry ${index + 1}: Collection Code is required`)
                if (row.tdsAmount === '' || row.tdsAmount === null || row.tdsAmount === undefined) errors.push(`TCS Entry ${index + 1}: TCS Amount is required`)
                if (!row.dateOfPayment) errors.push(`TCS Entry ${index + 1}: Date where amount received is required`)
                if (!row.dateOfDeduction && (parseFloat(row.tdsAmount || 0) + parseFloat(row.surcharge || 0) + parseFloat(row.cess || 0)) > 0) errors.push(`TCS Entry ${index + 1}: Date on which tax collected is required`)
                if (parseFloat(row.tdsAmount) > 0 && !row.challanId) errors.push(`TCS Entry ${index + 1}: Challan Selection is required`)
            })
        }

        if (challanData && challanData.length > 0) {
            challanData.forEach((row, index) => {
                if (!row.tdsAmount || parseFloat(row.tdsAmount) <= 0) errors.push(`Challan Entry ${index + 1}: TCS Amount is required`)
                if (!row.dateOfDeposit) errors.push(`Challan Entry ${index + 1}: Date of Deposit is required`)
                if (!row.bsrCode) errors.push(`Challan Entry ${index + 1}: BSR Code is required`)
                else if (row.bsrCode.length !== 7) errors.push(`Challan Entry ${index + 1}: BSR Code must be 7 digits`)
                if (!row.challanSerialNo) errors.push(`Challan Entry ${index + 1}: Challan Serial No. is required`)
                else if (row.challanSerialNo.length !== 5) errors.push(`Challan Entry ${index + 1}: Challan Serial No. must be 5 digits`)
            })
        }
        return errors
    }

    function generateTdsStatementFile() {
        const fileCreationDate = new Date().toLocaleDateString('en-GB').replace(/\//g, '')
        let financialYear = ''
        let fyStartYear = 0
        if (selectedFinancialYear) {
            const parts = selectedFinancialYear.split('-')
            if (parts.length >= 2) {
                fyStartYear = parseInt(parts[0])
                const yearPart2 = parts[1].length === 4 ? parts[1].slice(-2) : parts[1]
                financialYear = `${parts[0]}${yearPart2}`
            }
        }
        if (!fyStartYear || isNaN(fyStartYear)) {
            const today = new Date()
            fyStartYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1
            financialYear = `${fyStartYear}${String(fyStartYear + 1).slice(-2)}`
        }
        const ayStart = fyStartYear + 1
        const assessmentYear = `${ayStart}${String(ayStart + 1).slice(-2)}`

        let fileContent = ''
        let lineNumber = 1
        const section1 = profileData?.section1 || {}
        const section2 = profileData?.section2 || {}
        const section3 = profileData?.section3 || {}

        const isPanOnlyChange = (tds) => {
            const original = originalTdsData.find(o => o.id === tds.id)
            if (!original) return false
            if (tds.consoMode === 'F') return false
            const panChanged = (tds.panOfDeductee || '') !== (original.panOfDeductee || '')
            if (!panChanged) return false
            const amountSame = parseFloat(tds.tdsAmount || 0) === parseFloat(original.tdsAmount || 0)
            const sectionSame = (tds.sectionCode || '') === (original.sectionCode || '')
            const dateSame = (tds.dateOfPayment || '') === (original.dateOfPayment || '')
            const amtSame = parseFloat(tds.amountOfPayment || 0) === parseFloat(original.amountOfPayment || 0)
            return amountSame && sectionSame && dateSame && amtSame
        }

        const isBhChanged = () => {
            if (!originalProfileData) return false;
            const s1Keys = ['typeOfDeduction'];
            const s2Keys = ['name', 'branchDivision', 'flatNo', 'nameOfPremises', 'roadStreet', 'areaLocality', 'townCity', 'pinCode', 'state', 'email', 'stdCode', 'telephoneNo'];
            const s3Keys = ['name', 'designation', 'flatNo', 'nameOfPremises', 'roadStreet', 'areaLocality', 'townCity', 'pinCode', 'state', 'email', 'mobileNo', 'telephone', 'permanentAccountNumber'];

            const changed1 = s1Keys.some(k => (profileData.section1?.[k] || '') !== (originalProfileData.section1?.[k] || ''));
            const changed2 = s2Keys.some(k => (profileData.section2?.[k] || '') !== (originalProfileData.section2?.[k] || ''));
            const changed3 = s3Keys.some(k => (profileData.section3?.[k] || '') !== (originalProfileData.section3?.[k] || ''));

            return changed1 || changed2 || changed3;
        }

        const isCdChanged = () => {
            if (!originalChallanData) return challanData.length > 0;
            if (challanData.length !== originalChallanData.length) return true;
            return challanData.some((c, idx) => {
                const o = originalChallanData[idx];
                if (!o) return true;
                return c.challanSerialNo !== o.challanSerialNo ||
                    c.bsrCode !== o.bsrCode ||
                    c.dateOfDeposit !== o.dateOfDeposit ||
                    parseFloat(c.tdsAmount || 0) !== parseFloat(o.tdsAmount || 0);
            });
        }

        const isDdChanged = () => {
            if (!originalTdsData) return tdsData.length > 0;
            if (tdsData.length !== originalTdsData.length) return true;
            return tdsData.some((t, idx) => {
                const o = originalTdsData[idx];
                if (!o) return true;
                return t.amountOfPayment !== o.amountOfPayment ||
                    t.dateOfPayment !== o.dateOfPayment ||
                    t.sectionCode !== o.sectionCode ||
                    parseFloat(t.tdsAmount || 0) !== parseFloat(o.tdsAmount || 0);
            });
        }

        const isPanUpdated = () => {
            return tdsData.some(t => t.panOfDeductee && t.originalPan && t.panOfDeductee !== t.originalPan);
        }



        // STEP 2: Classify challans
        const challanGroups = challanData.map(challan => {
            const allDDs = tdsData.filter(t => t.challanId == challan.id)
            const changedDDs = allDDs.filter(tds => {
                const original = originalTdsData.find(o => o.id === tds.id)
                return !original || JSON.stringify(tds) !== JSON.stringify(original)
            })
            const originalChallan = originalChallanData.find(c => c.id === challan.id)
            const challanChanged = !originalChallan ||
                challan.challanSerialNo !== originalChallan.challanSerialNo ||
                challan.bsrCode !== originalChallan.bsrCode ||
                challan.dateOfDeposit !== originalChallan.dateOfDeposit ||
                parseFloat(challan.tdsAmount || 0) !== parseFloat(originalChallan.tdsAmount || 0)
            return {
                challan,
                panOnlyDDs: changedDDs.filter(isPanOnlyChange),
                otherDDs: changedDDs.filter(t => !isPanOnlyChange(t)),
                challanChanged
            }
        })

        // STEP 3: Determine batches needed
        const c5Groups = challanGroups.filter(g => g.panOnlyDDs.length > 0)
        const c3Groups = challanGroups.filter(g => g.otherDDs.length > 0)
        const c2Groups = challanGroups.filter(g => g.challanChanged && g.panOnlyDDs.length === 0 && g.otherDDs.length === 0)

        const batches = []
        if (c5Groups.length > 0) batches.push({ type: 'C5', groups: c5Groups })
        if (c2Groups.length > 0) batches.push({ type: 'C2', groups: c2Groups })
        if (c3Groups.length > 0) batches.push({ type: 'C3', groups: c3Groups })
        if (batches.length === 0 && isBhChanged()) batches.push({ type: 'C1', groups: [] })
        if (batches.length === 0) {
            const changed = challanGroups.filter(g => g.otherDDs.length > 0 || g.challanChanged)
            batches.push({ type: 'C3', groups: changed })
        }
        const totalBatches = batches.length

        // 1. File Header Record (FH)
        const fh = []
        fh[1] = lineNumber                   // 1. Line Number (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[2] = 'FH'                         // 2. Record Type (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[3] = 'TC1'                        // 3. File Type (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[4] = 'C'                          // 4. Upload Type (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[5] = fileCreationDate             // 5. File Creation Date (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[6] = '1'                          // 6. File Sequence No. (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[7] = 'D'                          // 7. Uploader Type (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[8] = section1.taxDeduction || ''  // 8. TAN of Deductor (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[9] = String(totalBatches)         // 9. Total No. of Batches (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[10] = 'Tax Eases Client'          // 10. Name of Return Preparation Utility (Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[11] = ''                          // 11. Record Hash (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[12] = ''                          // 12. FVU Version (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[13] = ''                          // 13. File Hash (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[14] = ''                          // 14. Sam Version (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[15] = ''                          // 15. SAM Hash (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[16] = ''                          // 16. SCM Version (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[17] = ''                          // 17. SCM Hash (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
        fh[18] = consoFhHash || ''           // 18. Consolidated File Hash (Ref: Form_27EQ_Correction_FH_Fields.md)
        fileContent += fh.slice(1, 19).join('^') + '\n'; lineNumber++;

        // Helper: build BH
        const buildBH = (batchNo, corrType, includesBhChanges, batchTotalAmt) => {
            const dAddr1 = `${section2.flatNo || ''} ${section2.nameOfPremises || ''} ${section2.roadStreet || ''}`.trim()
            const rAddr1 = `${section3.flatNo || ''} ${section3.nameOfPremises || ''} ${section3.roadStreet || ''}`.trim()
            const bh = []
            const updInd = includesBhChanges ? '1' : '0'
            bh[1] = lineNumber                       // 1. Line Number (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[2] = 'BH'                             // 2. Record Type (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[3] = String(batchNo)                  // 3. Batch Number (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[4] = ''                               // 4. Record Count (Placeholder, set in calling loop)
            const isNewFormat = fyStartYear >= 2026;
            bh[5] = isNewFormat ? '143' : '27EQ'                           // 5. Form Number (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[6] = corrType                         // 6. Transaction Type (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[7] = updInd                           // 7. Batch Updation Indicator (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[8] = section1.receiptNoOriginal || '' // 8. Token Number of original statement (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[9] = section1.receiptNoEarlier || ''  // 9. Previous statement Token Number (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[10] = ''                              // 10. Token Number (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[11] = ''                              // 11. Date of Token Number (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[12] = section1.taxDeduction || ''     // 12. Last TAN of Collector (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[13] = section1.taxDeduction || ''     // 13. TAN of Collector (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[14] = ''                              // 14. Receipt number (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[15] = section1.permanentAccountNumber || '' // 15. PAN of Collector (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[16] = assessmentYear                  // 16. Assessment Year (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[17] = financialYear                   // 17. Financial Year (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[18] = selectedQuarter                 // 18. Period (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[19] = padString(section2.name, 75)    // 19. Name of Collector (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[20] = padString(section2.branchDivision, 75) // 20. Branch/Division (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[21] = padString(dAddr1, 25)           // 21. Address 1 (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[22] = padString(section2.areaLocality, 25) // 22. Address 2 (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[23] = padString(section2.townCity, 25) // 23. Address 3 (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[24] = ''                              // 24. Address 4 (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[25] = ''                              // 25. Address 5 (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[26] = getStateCode(section2.state)    // 26. State Code (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[27] = section2.pinCode || ''          // 27. PIN Code (Ref: Form_27EQ_Correction_FH_Fields.md)
            const deductorStdCode = section2.stdCode || '91'
            const respPersonStdCode = (section3.sameAsAbove ? section2.stdCode : section3.stdCode) || section2.stdCode || '91'
            const respPersonTelephone = (section3.sameAsAbove ? section2.telephoneNo : (section3.telephone || section3.telephoneNo)) || ''

            bh[28] = padString(section2.email, 75)   // 28. Email ID (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[29] = deductorStdCode                 // 29. STD Code (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[30] = section2.telephoneNo || ''      // 30. Telephone No. (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[31] = 'N'                             // 31. Change of Address Collector (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[32] = section1.typeOfDeduction || ''  // 32. Collector Type (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[33] = padString(section3.name, 75)    // 33. Name of Resp Person (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[34] = padString(section3.designation, 20) // 34. Designation (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[35] = padString(rAddr1, 25)           // 35. Resp Person Address 1 (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[36] = padString(section3.areaLocality, 25) // 36. Resp Person Address 2 (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[37] = padString(section3.townCity, 25) // 37. Resp Person Address 3 (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[38] = ''                              // 38. Resp Person Address 4 (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[39] = ''                              // 39. Resp Person Address 5 (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[40] = getStateCode(section3.state)    // 40. Resp Person State Code (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[41] = section3.pinCode || ''          // 41. Resp Person PIN Code (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[42] = padString(section3.email, 75)   // 42. Resp Person Email ID (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[43] = section3.mobileNo || ''         // 43. Mobile Number (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[44] = respPersonStdCode               // 44. Resp Person STD Code (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[45] = respPersonTelephone             // 45. Resp Person Telephone (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[46] = section3.hasAddressChanged === 'Yes' ? 'Y' : 'N' // 46. Change of Address Resp Person (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[47] = formatDecimalAmount(batchTotalAmt) // 47. Batch Total Deposit Amount (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[48] = ''                              // 48. Unmatched challan count (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[49] = ''                              // 49. Count Salary Records (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[50] = ''                              // 50. Total Salary Income (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[51] = 'N'                             // 51. AO Approval (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[52] = ''                              // 52. Earlier period filed (Must be empty for correction)
            bh[53] = originalProfileData?.section1?.typeOfDeduction || section1.typeOfDeduction || '' // 53. Last Deductor Type (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[54] = ''                              // 54. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[55] = ''                              // 55. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[56] = ''                              // 56. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[57] = ''                              // 57. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[58] = ''                              // 58. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[59] = section3.permanentAccountNumber || '' // 59. PAN of Responsible Person (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[60] = ''                              // 60. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[61] = ''                              // 61. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[62] = ''                              // 62. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[63] = ''                              // 63. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[64] = ''                              // 64. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[65] = ''                              // 65. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[66] = ''                              // 66. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[67] = ''                              // 67. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[68] = ''                              // 68. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[69] = section2.gstin || ''           // 69. GSTIN of Collector (Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[70] = '';                            // 70. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[71] = '';                            // 71. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            bh[72] = ''                             // 72. (No Value per Ref: Form_27EQ_Correction_FH_Fields.md)
            return bh
        }

        // Calculate highest challan record number in original conso file
        const maxConsoChallanRecordNo = Math.max(0, ...challanData
            .filter(c => c.source === 'conso' || (c.recordNo && parseInt(c.recordNo, 10) > 0))
            .map(c => parseInt(c.recordNo || 0, 10)))
        let nextAddedChallanNo = maxConsoChallanRecordNo + 1
        const assignedChallanRecordNos = new Map()

        const getChallanRecordNo = (challan) => {
            if (challan.recordNo && parseInt(challan.recordNo, 10) > 0) {
                return parseInt(challan.recordNo, 10)
            }
            if (!assignedChallanRecordNos.has(challan.id)) {
                assignedChallanRecordNos.set(challan.id, nextAddedChallanNo++)
            }
            return assignedChallanRecordNos.get(challan.id)
        }

        // Per-challan counter for additions starting after the last record no of DD in that challan
        const nextDeducteeNoByChallan = {}
        const getNextDeducteeNo = (challanId) => {
            if (nextDeducteeNoByChallan[challanId] === undefined) {
                const existingConsoDDs = tdsData.filter(t => t.challanId == challanId && t.source === 'conso' && t.recordNo)
                const maxNo = Math.max(0, ...existingConsoDDs.map(t => parseInt(t.recordNo, 10)))
                nextDeducteeNoByChallan[challanId] = maxNo + 1
            }
            return nextDeducteeNoByChallan[challanId]++
        }

        // Helper: emit CD + DD
        const emitCDDD = (challan, dds, batchNo, challanRecordNo, isChallanUpdation, batchType) => {
            const cd = []
            const eduCess = parseFloat(challan.educationCess || 0) + parseFloat(challan.higherEducationCess || 0)

            const getOldVal = (origVal1, origVal2, fallbackVal1, fallbackVal2) => {
                if (origVal1 !== undefined && origVal1 !== null && origVal1 !== '' && !isNaN(Number(origVal1))) return parseFloat(origVal1)
                if (origVal2 !== undefined && origVal2 !== null && origVal2 !== '' && !isNaN(Number(origVal2))) return parseFloat(origVal2)
                if (fallbackVal1 !== undefined && fallbackVal1 !== null && fallbackVal1 !== '' && !isNaN(Number(fallbackVal1))) return parseFloat(fallbackVal1)
                if (fallbackVal2 !== undefined && fallbackVal2 !== null && fallbackVal2 !== '' && !isNaN(Number(fallbackVal2))) return parseFloat(fallbackVal2)
                return 0
            }

            let cdTdsSum = 0
            let cdSurchSum = 0
            let cdCessSum = 0
            let cdTotalSum = 0

            if (batchType === 'C3' || batchType === 'C5') {
                dds.forEach(tds => {
                    const isNew = tds.source !== 'conso'
                    let mode = 'U'
                    if (isNew) mode = 'A'
                    else if (tds.consoMode === 'F') mode = 'F'

                    const tdsVal = parseFloat(tds.tdsAmount || 0)
                    const surchargeVal = parseFloat(tds.surcharge || 0)
                    const cessVal = parseFloat(tds.cess || 0)
                    const totTax = tdsVal + surchargeVal + cessVal

                    if (mode === 'A') {
                        cdTdsSum += tdsVal
                        cdSurchSum += surchargeVal
                        cdCessSum += cessVal
                        cdTotalSum += totTax
                    } else if (mode === 'U') {
                        const originalTds = originalTdsData 
                            ? (originalTdsData.find(o => o.id === tds.id) || originalTdsData.find(o => o.recordNo && o.recordNo == tds.recordNo && o.challanId == tds.challanId))
                            : null

                        const oldTdsVal = getOldVal(originalTds?.originalTdsAmount, tds.originalTdsAmount, originalTds?.tdsAmount, tds.tdsAmount)
                        const oldSurchVal = getOldVal(originalTds?.originalSurcharge, tds.originalSurcharge, originalTds?.surcharge, tds.surcharge)
                        const oldCessVal = getOldVal(originalTds?.originalCess, tds.originalCess, originalTds?.cess, tds.cess)
                        const oldTotTax = (originalTds?.originalTotalTax !== undefined && originalTds.originalTotalTax !== null && originalTds.originalTotalTax !== '' && !isNaN(Number(originalTds.originalTotalTax)))
                            ? parseFloat(originalTds.originalTotalTax)
                            : (tds.originalTotalTax !== undefined && tds.originalTotalTax !== null && tds.originalTotalTax !== '' && !isNaN(Number(tds.originalTotalTax))
                                ? parseFloat(tds.originalTotalTax)
                                : (oldTdsVal + oldSurchVal + oldCessVal))

                        cdTdsSum += (tdsVal - oldTdsVal)
                        cdSurchSum += (surchargeVal - oldSurchVal)
                        cdCessSum += (cessVal - oldCessVal)
                        cdTotalSum += (totTax - oldTotTax)
                    }
                })
            } else {
                cdTdsSum = dds.reduce((a, b) => a + parseFloat(b.tdsAmount || 0), 0)
                cdSurchSum = dds.reduce((a, b) => a + parseFloat(b.surcharge || 0), 0)
                cdCessSum = dds.reduce((a, b) => a + parseFloat(b.cess || 0), 0)
                cdTotalSum = cdTdsSum + cdSurchSum + cdCessSum
            }

            cd[1] = lineNumber                       // 1. Line Number (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[2] = 'CD'                             // 2. Record Type (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[3] = String(batchNo)                  // 3. Batch Number (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[4] = challanRecordNo                  // 4. Challan Record Number (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[5] = dds.length                       // 5. Count of Party Records (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[6] = 'N'                              // 6. NIL Challan Indicator (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[7] = isChallanUpdation ? '1' : '0'    // 7. Challan Updation Indicator (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[8] = ''                               // 8. Filler (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[9] = ''                               // 9. Filler (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[10] = ''                              // 10. Filler (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[11] = challan.originalChallanNo || ''    // 11. Last Bank Challan Number (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[12] = challan.challanSerialNo || ''   // 12. Bank Challan No. (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[13] = ''                              // 13. Last DDO Serial No. (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[14] = ''                              // 14. DDO Serial No. (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[15] = challan.originalBsrCode || ''      // 15. Last Bank Branch Code (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[16] = challan.bsrCode || ''           // 16. Bank Branch Code (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[17] = challan.originalDateOfDeposit || '' // 17. Last Date of Bank Challan (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[18] = formatDate(challan.dateOfDeposit) // 18. Date of Bank Challan (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[19] = ''                              // 19. Filler (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[20] = ''                              // 20. Filler (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[21] = challan.section || ''           // 21. Section (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[22] = isChallanUpdation ? formatDecimalAmount(challan.tdsAmount) : '' // 22. TCS Income Tax (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[23] = isChallanUpdation ? formatDecimalAmount(challan.surcharge) : '' // 23. TCS Surcharge (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[24] = isChallanUpdation ? formatDecimalAmount(eduCess) : ''    // 24. TCS Cess (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[25] = isChallanUpdation ? formatDecimalAmount(challan.interest) : '' // 25. TCS Interest (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[26] = isChallanUpdation ? formatDecimalAmount(challan.other) : '' // 26. TCS Others (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[27] = formatDecimalAmount(challan.totalAmount) // 27. Total Deposit Amount (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[28] = formatDecimalAmount(challan.totalAmount) // 28. Last Total Deposit Amount (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[29] = formatDecimalAmount(cdTotalSum) // 29. Total Tax Deposit per Annexure (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[30] = formatDecimalAmount(cdTdsSum) // 30. Sum DD Income Tax (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[31] = formatDecimalAmount(cdSurchSum) // 31. Sum DD Surcharge (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[32] = formatDecimalAmount(cdCessSum)    // 32. Sum DD Cess (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[33] = formatDecimalAmount(cdTotalSum) // 33. Sum DD Total TCS (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[34] = formatDecimalAmount(challan.interest || 0) // 34. TCS Interest (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[35] = formatDecimalAmount(challan.other || 0)    // 35. TCS Others (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[36] = ''                              // 36. Cheque/DD No. (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[37] = challan.bookEntry ? 'Y' : 'N'   // 37. By Book Entry / Cash (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[38] = ''                              // 38. Remarks (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[39] = formatDecimalAmount(challan.feesAmount) // 39. Fee (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[40] = isChallanUpdation ? formatMinorHead27EQ(challan.minorHead) : '' // 40. Minor Head (Ref: Form_27EQ_Correction_CD_Fields.md)
            cd[41] = ''                              // 41. Record Hash (No Value per Ref: Form_27EQ_Correction_CD_Fields.md)
            fileContent += cd.slice(1).join('^') + '\n'
            lineNumber++

            // Ensure records are in increasing order of their original record number (for Updates)
            // New records (Additions) will follow at the end.
            const sortedDds = [...dds].sort((a, b) => {
                const aNo = a.source === 'conso' ? parseInt(a.recordNo || 0) : 999999
                const bNo = b.source === 'conso' ? parseInt(b.recordNo || 0) : 999999
                return aNo - bNo
            })

            const seenRecordNos = new Set()
            sortedDds.forEach((tds) => {
                const dd = []
                const rate = parseFloat(tds.rateOfTax || 0)
                const tdsVal = parseFloat(tds.tdsAmount || 0)
                const surchargeVal = parseFloat(tds.surcharge || 0)
                const cessVal = parseFloat(tds.cess || 0)
                const totalTax = tdsVal + surchargeVal + cessVal
                const isNew = tds.source !== 'conso'
                let mode = 'U'
                if (isNew) mode = 'A'
                else if (tds.consoMode === 'F') mode = 'F'

                const originalTds = originalTdsData ? originalTdsData.find(o => o.id === tds.id) : null
                let recordNo = isNew ? getNextDeducteeNo(challan.id) : (parseInt(tds.recordNo, 10) || tds.recordNo)
                if (!recordNo || seenRecordNos.has(String(recordNo))) {
                    recordNo = getNextDeducteeNo(challan.id)
                }
                seenRecordNos.add(String(recordNo))
                dd[1] = lineNumber                   // 1. Line Number (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[2] = 'DD'                         // 2. Record Type (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[3] = String(batchNo)              // 3. Batch Number (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[4] = challanRecordNo              // 4. Challan Record Number (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[5] = recordNo                     // 5. Party Detail Record No (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[6] = mode                         // 6. Mode (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[7] = ''                           // 7. Filler (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[8] = String(parseInt(tds.deducteeCode || '10', 10)) // 8. Collectee Code (1-10, strip leading zeros)
                dd[9] = mode === 'U' ? (tds.originalPan || '') : '' // 9. Last Party PAN (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[10] = String(tds.panOfDeductee || '').replace(/[\r\n]/g, '').trim()     // 10. Party PAN (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[11] = mode === 'U' ? (tds.originalRefNo || '') : '' // 11. Last PAN Ref. No. (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[12] = tds.deducteeReferenceNo || '' // 12. Party Reference No. (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[13] = padString(tds.firstName || '', 75) // 13. Name of Party (Ref: Form_27EQ_Correction_DD_Fields.md)

                const getOrigTax = (item) => {
                  if (!item) return 0
                  if (item.originalTotalTax !== undefined && item.originalTotalTax !== null && item.originalTotalTax !== '' && !isNaN(Number(item.originalTotalTax))) {
                    return parseFloat(item.originalTotalTax)
                  }
                  const t = parseFloat(item.tdsAmount || 0)
                  const s = parseFloat(item.surcharge || 0)
                  const c = parseFloat(item.cess || 0)
                  return t + s + c
                }

                const getOrigTaxDeposited = (item) => {
                  if (!item) return 0
                  if (item.originalTotalTaxDeposited !== undefined && item.originalTotalTaxDeposited !== null && item.originalTotalTaxDeposited !== '' && !isNaN(Number(item.originalTotalTaxDeposited))) {
                    return parseFloat(item.originalTotalTaxDeposited)
                  }
                  return getOrigTax(item)
                }

                const lastTotalTax = originalTds ? getOrigTax(originalTds) : getOrigTax(tds)
                const lastTotalTaxDeposited = originalTds ? getOrigTaxDeposited(originalTds) : getOrigTaxDeposited(tds)

                dd[14] = formatDecimalAmount(tdsVal) // 14. TCS Income Tax (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[15] = formatDecimalAmount(surchargeVal) // 15. TCS Surcharge (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[16] = formatDecimalAmount(cessVal) // 16. Health & Edu Cess (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[17] = formatDecimalAmount(totalTax) // 17. Total TCS collected (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[18] = mode === 'U' ? formatDecimalAmount(lastTotalTax) : '' // 18. Last Total TCS (before updation)
                dd[19] = formatDecimalAmount(totalTax) // 19. Total TCS Deposited (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[20] = mode === 'U' ? formatDecimalAmount(lastTotalTaxDeposited) : '' // 20. Last Total TCS Deposited (before updation)
                dd[21] = formatDecimalAmount(tds.purchaseValue || 0) // 21. Total Value of Purchase (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[22] = formatDecimalAmount(tds.amountOfPayment) // 22. Amount of receipt/debited (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[23] = formatDate(tds.dateOfPayment) // 23. Date of receipt/debited (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[24] = totalTax > 0 ? formatDate(tds.dateOfDeduction) : '' // 24. Date of tax collected (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[25] = ''                          // 25. Date of Deposit (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[26] = rate.toFixed(4)             // 26. Rate of Collection (Ref: Form_27EQ_Correction_DD_Fields.md)
                for (let i = 27; i <= 29; i++) dd[i] = '' // 27-29. Fillers (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[30] = isNew ? (tds.reasonForNonDeduction || '') : (originalTds?.reasonForNonDeduction || '') // 30. Remarks 1 (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[31] = ''                          // 31. Resident/Non-resident (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[32] = ''                          // 32. Permanent Establishment (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[33] = tds.sectionCode || '206C'   // 33. Section Code (Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[34] = tds.certificateNo197 || ''  // 34. Certificate No u/s 197 (Ref: Form_27EQ_Correction_DD_Fields.md)
                for (let i = 35; i <= 53; i++) dd[i] = '' // 35-53. Fillers (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                dd[54] = ''                          // 54. Record Hash (No Value per Ref: Form_27EQ_Correction_DD_Fields.md)
                fileContent += dd.slice(1).join('^') + '\n'
                lineNumber++
            })
        }

        // STEP 4: Emit all batches
        const bhC = isBhChanged()
        batches.forEach((batch, batchIdx) => {
            const batchNo = batchIdx + 1
            const batchTotalAmt = batch.groups.reduce((sum, g) => sum + parseFloat(g.challan.totalAmount || 0), 0)
            const includesBhChanges = batch.type === 'C5' ? false : bhC
            const cdCount = batch.groups.length
            const bhArr = buildBH(batchNo, batch.type, includesBhChanges, batchTotalAmt)
            bhArr[4] = (batch.type === 'C1') ? '' : cdCount
            fileContent += bhArr.slice(1).join('^') + '\n'
            lineNumber++
            if (batch.type === 'C1') return
            batch.groups.forEach(g => {
                const dds = batch.type === 'C5' ? g.panOnlyDDs : g.otherDDs
                const isChallanUpd = g.challanChanged && batch.type !== 'C5'
                const challanRecordNo = getChallanRecordNo(g.challan)
                emitCDDD(g.challan, dds, batchNo, challanRecordNo, isChallanUpd, batch.type)
            })
        })

        return fileContent
    }





    const handleCsiFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setCsiFile(e.target.files[0])
            setShowCsiUploadPopup(false)
            executeValidation(e.target.files[0])
        }
    }

    const handleCsiDownload = async () => {
        if (!downloadPassword) {
            toast.error('Please enter Income Tax Portal Password');
            return;
        }

        setIsDownloadingCsi(true);
        try {
            const { from, to } = challanDateRange;
            if (!from || !to) {
                toast.error('Could not determine date range from challans. Please upload CSI manually.');
                setIsDownloadingCsi(false);
                return;
            }

            const response = await axios.post('/api/login-income-tax', {
                credentials: {
                    tan: profileData?.section1?.taxDeduction || profileData?.section1?.tan,
                    password: downloadPassword
                },
                dateRange: { from, to }
            });

            if (response.data.success && response.data.csiContent) {
                toast.success('CSI File Downloaded Successfully!');
                setShowDownloadPrompt(false);
                if (typeof setDownloadPassword === 'function') setDownloadPassword('');

                const binaryString = window.atob(response.data.csiContent.replace(/\s/g, ''));
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const file = new File([bytes], response.data.fileName || 'downloaded.csi', { type: 'text/plain' });
                if (typeof setCsiFile === 'function') setCsiFile(file);
                if (typeof executeValidation === 'function') executeValidation(file);
            } else {
                const errMsg = response.data.error || 'Failed to download CSI file. Please check password.';
                toast.error(errMsg);
            }
        } catch (error) {
            console.error('CSI Download Error:', error);
            toast.error('An error occurred during download');
        } finally {
            setIsDownloadingCsi(false);
        }
    };

    const handleProfilePrefill = async () => {
        if (!prefillPassword) {
            toast.error('Portal password is required');
            return;
        }

        setIsExtractingProfile(true);
        try {
            const { success, data, error } = await extractProfileDataApi({
                tan: profileData.section1?.taxDeduction,
                password: prefillPassword
            });

            if (success && data) {
                const newData = { ...profileData };
                if (data.pan) {
                    newData.section1.permanentAccountNumber = data.pan;
                    if (newData.section3) newData.section3.permanentAccountNumber = data.pan;
                }
                if (data.name) {
                    newData.section2.name = data.name;
                }
                if (data.keyPerson) {
                    if (data.keyPerson.name) newData.section3.name = data.keyPerson.name;
                    if (data.keyPerson.pan) newData.section3.permanentAccountNumber = data.keyPerson.pan;
                }
                if (data.email) {
                    newData.section2.email = data.email;
                    if (newData.section3) newData.section3.email = data.email;
                }
                if (data.mobile && newData.section3) {
                    newData.section3.mobileNo = data.mobile;
                }

                if (data.address) {
                    newData.section2.flatNo = data.address.flatNo || '';
                    newData.section2.nameOfPremises = data.address.premisesName || '';
                    newData.section2.roadStreet = data.address.roadStreet || '';
                    newData.section2.areaLocality = data.address.areaLocality || '';
                    newData.section2.townCity = data.address.city || '';
                    newData.section2.pinCode = data.address.pinCode || '';
                    newData.section2.pinCode = data.address.pinCode || '';

                    // Enhanced State Matching
                    if (data.address.state) {
                        const upperState = data.address.state.toUpperCase().trim();
                        // Try explicit match first, then partial
                        const matchedState = stateOptions.find(opt => opt === upperState) ||
                            stateOptions.find(opt => upperState.includes(opt) || opt.includes(upperState));

                        if (matchedState) {
                            newData.section2.state = matchedState;
                        } else {
                            // Fallback: If no match found, don't set invalid value for dropdown
                            console.warn('State mismatch:', data.address.state);
                        }
                    }

                    if (newData.section3 && newData.section3.sameAsAbove) {
                        newData.section3.flatNo = newData.section2.flatNo;
                        newData.section3.nameOfPremises = newData.section2.nameOfPremises;
                        newData.section3.roadStreet = newData.section2.roadStreet;
                        newData.section3.areaLocality = newData.section2.areaLocality;
                        newData.section3.townCity = newData.section2.townCity;
                        newData.section3.pinCode = newData.section2.pinCode;
                        newData.section3.state = newData.section2.state;
                    }
                }

                setProfileData(newData);
                // Cloud sync via updateProfileData);
                toast.success('Profile data pre-filled successfully!');
                setShowPrefillPrompt(false);
                setPrefillPassword('');
            } else {
                toast.error(error || 'Extraction failed');
            }
        } catch (error) {
            toast.error('Extraction Failed: ' + (error.message));
        } finally {
            setIsExtractingProfile(false);
        }
    };

    const parseConsoFile = (consoText) => {
        try {
            const lines = consoText.split('\n')

            // Validate BH record form type
            const bhLine = lines.find(l => {
                const p = l.split('^')
                return p[1] === 'BH'
            })

            if (bhLine) {
                const bhParts = bhLine.split('^')
                const formInConso = (bhParts[4] || '').toUpperCase().trim()
                if (formInConso && formInConso !== '27EQ' && formInConso !== '143') {
                    toast.error(`Invalid Conso File! Expected Form 27EQ, but file contains Form ${formInConso}.`)
                    alert(`Invalid Conso File!\n\nThis form is Form 27EQ, but the uploaded Conso file belongs to Form ${formInConso}.\nPlease upload the correct Form 27EQ Conso file.`)
                    return
                }
            }

            const newChallans = []
            const newTdsData = []
            let currentChallan = null
            let rowIndex = 1

            lines.forEach(line => {
                if (!line.trim()) return
                const parts = line.split('^')
                const recordType = parts[1]

                if (recordType === 'FH') {
                    // Extract FH field 15 (Consolidated file hash) — parts[14] (0-based)
                    setConsoFhHash(parts[14] || '')
                } else if (recordType === 'BH') {
                    const getMappedState = (code) => {
                        if (!code) return '';
                        const padded = code.padStart(2, '0');
                        return reverseStateCodes[padded] || reverseStateCodes[code] || '';
                    };
                    const bhData = {
                        section1: {
                            taxDeduction: parts[12] || '', // TAN (Field 13)
                            permanentAccountNumber: parts[14] || '', // PAN (Field 15)
                            typeOfDeduction: parts[31] || '', // Type/Status (Field 32)
                            receiptNoOriginal: parts[7] || '', // Token No (Field 8)
                            receiptNoEarlier: parts[8] || '', // Prev Token No (Field 9)
                            isEarlierReturnFiled: parts[51] === 'Y' ? 'Yes' : 'No' // Field 52
                        },
                        section2: {
                            name: parts[18] || '', // Field 19
                            branchDivision: parts[19] || '', // Field 20
                            flatNo: parts[20] || '', // Field 21
                            nameOfPremises: parts[21] || '', // Field 22
                            roadStreet: parts[22] || '', // Field 23
                            areaLocality: parts[23] || '', // Field 24
                            townCity: parts[24] || '', // Field 25
                            state: getMappedState(parts[25]), // Field 26
                            pinCode: parts[26] || '', // Field 27
                            email: parts[27] || '', // Field 28
                            stdCode: parts[28] || '', // Field 29
                            telephoneNo: parts[29] || '', // Field 30
                            gstin: parts[68] || '', // Field 69
                        },
                        section3: {
                            name: parts[32] || '', // Field 33
                            designation: parts[33] || '', // Field 34
                            flatNo: parts[34] || '', // Field 35
                            nameOfPremises: parts[35] || '', // Field 36
                            roadStreet: parts[36] || '', // Field 37
                            areaLocality: parts[37] || '', // Field 38
                            townCity: parts[38] || '', // Field 39
                            state: getMappedState(parts[39]), // Field 40
                            pinCode: parts[40] || '', // Field 41
                            email: parts[41] || '', // Field 42
                            mobileNo: parts[47] || '', // Field 48 (TRACES Conso)
                            stdCode: parts[43] || '', // Field 44
                            telephone: parts[44] || '', // Field 45
                            telephoneAlternate: parts[45] || '', // Field 46
                            permanentAccountNumber: parts[58] || '', // Field 59
                            hasAddressChanged: parts[46] === 'Y' ? 'Yes' : 'No', // Field 47
                            sameAsAbove: false
                        }
                    }
                    setProfileData(bhData)
                    setOriginalProfileData(JSON.parse(JSON.stringify(bhData)))
                    // Cloud sync via updateProfileData)
                    setBatchNumber(parts[2] || '1')
                    localStorage.setItem('tds27EQBatchNumber', parts[2] || '1')
                } else if (recordType === 'CD') {
                    const challan = {
                        id: Date.now() + rowIndex++,
                        challanSerialNo: parts[12] || '',
                        bsrCode: parts[16] || '',
                        dateOfDeposit: parts[18] ? `${parts[18].slice(4, 8)}-${parts[18].slice(2, 4)}-${parts[18].slice(0, 2)}` : '',
                        minorHead: parts[40] || '200',
                        tdsAmount: parseFloat(parts[22] || 0),
                        surcharge: parseFloat(parts[23] || 0),
                        educationCess: parseFloat(parts[24] || 0),
                        interest: parseFloat(parts[25] || 0),
                        other: parseFloat(parts[26] || 0),
                        totalAmount: parseFloat(parts[27] || 0),
                        feesAmount: parseFloat(parts[39] || 0),
                        bookEntry: parts[37] === 'Y',
                        recordNo: parts[3] ? parseInt(parts[3], 10) : '',
                        source: 'conso',
                        higherEducationCess: 0,
                        // Original fields for correction return "Last" values
                        originalChallanNo: parts[12] || '',
                        originalBsrCode: parts[16] || '',
                        originalDateOfDeposit: parts[18] || '', // Already DDMMYYYY in conso
                        originalTotalAmount: parts[27] || ''
                    }
                    currentChallan = challan
                    newChallans.push(challan)
                } else if (recordType === 'DD') {
                    if (!currentChallan) return
                    const fullName = (parts[13] || '').trim();
                    const origTds = parseFloat(parts[14] || 0)
                    const origSurch = parseFloat(parts[15] || 0)
                    const origCess = parseFloat(parts[16] || 0)
                    const computedTotalTax = origTds + origSurch + origCess
                    const origTotalTaxFromField = (parts[17] !== undefined && parts[17] !== '') ? parseFloat(parts[17]) : computedTotalTax
                    const origTotalTaxDepositedFromField = (parts[19] !== undefined && parts[19] !== '') ? parseFloat(parts[19]) : origTotalTaxFromField

                    const deductee = {
                        id: Date.now() + rowIndex++,
                        challanId: currentChallan.id,
                        deducteeCode: parts[8] || '02',
                        panOfDeductee: parts[10] || '',
                        originalPan: parts[10] || '',
                        firstName: fullName,
                        middleName: '',
                        lastName: '',
                        amountOfPayment: parseFloat(parts[21] || 0),
                        dateOfPayment: parts[22] ? `${parts[22].slice(4, 8)}-${parts[22].slice(2, 4)}-${parts[22].slice(0, 2)}` : '',
                        dateOfDeduction: parts[23] ? `${parts[23].slice(4, 8)}-${parts[23].slice(2, 4)}-${parts[23].slice(0, 2)}` : '', // Fixed slice index typo (parts[23] -> parts[24])
                        rateOfTax: parseFloat(parts[25] || 0).toFixed(2),
                        tdsAmount: origTds,
                        surcharge: origSurch,
                        cess: origCess,
                        sectionCode: parts[32] || parts[33] || '',  // Field 33 = Section Code
                        reasonForNonDeduction: parts[30] || '',
                        deducteeReferenceNo: parts[12] || '',
                        certificateNo197: parts[33] || '',       // Field 34 = Certificate No u/s 197
                        residentialStatus: parts[31] || '',
                        hasPE: parts[32] || '',
                        optOut115BAC: parts[49] || 'N',
                        source: 'conso',
                        recordNo: parts[4] || '',
                        challanRecordNo: parts[3] || '',
                        consoMode: parts[5] || '',
                        originalTotalTax: origTotalTaxFromField,
                        originalTotalTaxDeposited: origTotalTaxDepositedFromField,
                        originalTdsAmount: origTds,
                        originalSurcharge: origSurch,
                        originalCess: origCess,
                        originalRefNo: parts[12] || parts[11] || parts[4] || ''
                    }
                    newTdsData.push(deductee)
                }
            })

            setChallanData(newChallans)
            setStorageItem('tds27EQChallanData', newChallans)
            setOriginalChallanData(JSON.parse(JSON.stringify(newChallans)))
            setStorageItem('tds27EQOriginalChallanData', newChallans)

            setTdsData(newTdsData)
            setStorageItem('tds27EQTdsData', newTdsData)
            setOriginalTdsData(JSON.parse(JSON.stringify(newTdsData)))
            setStorageItem('tds27EQOriginalTdsData', newTdsData)

            toast.success('Conso File Uploaded and Parsed!')
        } catch (err) {
            console.error(err)
            toast.error('Error parsing conso file')
        }
    }

    const handleConsoFileUpload = (e) => {
        const file = e.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = (ev) => {
            setConsoFileContent(ev.target.result)
            parseConsoFile(ev.target.result)
        }
        reader.readAsText(file)
    }

        ;

    ;





    // Effect for Prepare Return signal


    const today = new Date();


    const currMonth = today.getMonth(); // 0=Jan, 3=Apr


    const currYear = today.getFullYear();


    const currentFyStart = currMonth >= 3 ? currYear : currYear - 1;





    const financialYearOptions = [];


    for (let start = currentFyStart; start >= 2023; start--) {


        financialYearOptions.push(`${start}-${(start + 1).toString().slice(-2)}`);


    }
    const quarterOptions = ['Q1', 'Q2', 'Q3', 'Q4'];
    const formOptions = ['24Q', '26Q', '27Q', '27EQ'];

    const handleClearData = () => {
        if (window.confirm('Are you sure you want to clear all data? This action cannot be undone.')) {
            const initialProfile = {
                section1: {
                    taxDeduction: '',
                    permanentAccountNumber: '',
                    typeOfDeduction: '',
                    receiptNoOriginal: '',
                    receiptNoEarlier: '',
                    isEarlierReturnFiled: 'No'
                },
                section2: {
                    name: '',
                    branchDivision: '',
                    flatNo: '',
                    nameOfPremises: '',
                    roadStreet: '',
                    areaLocality: '',
                    townCity: '',
                    pinCode: '',
                    state: '',
                    email: '',
                    stdCode: '',
                    telephoneNo: ''
                },
                section3: {
                    sameAsAbove: false,
                    name: '',
                    designation: '',
                    permanentAccountNumber: '',
                    nameOfPremises: '',
                    flatNo: '',
                    areaLocality: '',
                    roadStreet: '',
                    pinCode: '',
                    townCity: '',
                    telephone: '',
                    telephoneAlternate: '',
                    state: '',
                    email: '',
                    emailAlternate: '',
                    mobileNo: '',
                    hasAddressChanged: '',
                    hasRegularStatement: ''
                }
            }

            setChallanData([])
            setTdsData([])
            setOriginalTdsData([])
            setProfileData(initialProfile)

            localStorage.removeItem(getLegacyStorageKey('27EQ', 'ChallanData'))
            localStorage.removeItem(getLegacyStorageKey('27EQ', 'TdsData'))
            localStorage.removeItem(getLegacyStorageKey('27EQ', 'ProfileData'))
            localStorage.removeItem(getLegacyStorageKey('27EQ', 'OriginalTdsData'))

            toast.success('All data cleared successfully')
        }
    }


    return (
        <div className="min-h-screen bg-gray-50 w-full overflow-x-hidden">
            <ToastContainer position="top-right" autoClose={3000} />

            <header className={`bg-white shadow-sm border-b transition-all duration-300 ${!isMobile ? (sidebarState.isExpanded ? 'ml-64' : 'ml-14') : ''}`} style={{
                width: !isMobile ? (sidebarState.isExpanded ? 'calc(100% - 16rem)' : 'calc(100% - 3.5rem)') : '100%'
            }}>
                <div className="w-full px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16 relative">
                        <div className="flex items-center">
                            <FileText className="w-6 h-6 mr-2 text-blue-600" />
                        </div>
                        <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <h1 className="text-xl font-bold text-gray-800">Form 27EQ (TCS Return)</h1>
                        </div>
                        <button
                            onClick={handleClearData}
                            className="flex items-center text-red-600 hover:text-red-700 px-3 py-2 rounded-md text-sm font-medium hover:bg-red-50 transition-colors"
                        >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Clear Data
                        </button>
                    </div>
                </div>
            </header>

            <main className={`py-4 px-2 sm:px-4 lg:px-6 transition-all duration-300 ${!isMobile ? (sidebarState.isExpanded ? 'ml-64' : 'ml-14') : ''}`} style={{
                width: !isMobile ? (sidebarState.isExpanded ? 'calc(100% - 16rem)' : 'calc(100% - 3.5rem)') : '100%',
                maxWidth: '100%',
                overflowX: 'hidden',
                minHeight: 'calc(100vh - 4rem)'
            }}>


                {/* Selection Controls - Reused from others but logic for 27EQ */}
                <div className="bg-white rounded-lg shadow-sm p-4 mb-6 border border-gray-200">
                    <div className="flex flex-wrap gap-4 items-end">
                        <div className="flex-1 min-w-[180px] w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Financial Year <span className="text-red-500">*</span></label>
                            <select
                                value={selectedFinancialYear}
                                onChange={(e) => {
                                    const newYear = e.target.value;
                                    setSelectedFinancialYear(newYear);
                                    localStorage.setItem('tdsFinancialYear', newYear);

                                    // Auto-update selectedForm if it doesn't match the year's format
                                    if (newYear) {
                                        const isNewFormat = parseInt(newYear.split('-')[0]) >= 2026;
                                        setSelectedForm(prevForm => {
                                            const f = prevForm;
                                            const mapped = isNewFormat
                                                ? (f === '24Q' ? '138' : (f === '26Q' || f === '140') ? '140' : f === '27Q' ? '144' : f === '27EQ' ? '143' : f === '24Q4' ? '24Q4' : f)
                                                : (f === '138' ? '24Q' : (f === '140' || f === '26Q') ? '26Q' : f === '144' ? '27Q' : f === '143' ? '27EQ' : f === '24Q4' ? '24Q4' : f);
                                            if (mapped !== prevForm) {
                                                localStorage.setItem('tdsForm', mapped);
                                                return mapped;
                                            }
                                            return prevForm;
                                        });
                                    }
                                }}
                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md"
                            >
                                <option value="">Select FY</option>
                                {financialYearOptions.map(y => <option key={y} value={y}>{y}</option>)}
                            </select>
                        </div>

                        <div className="flex-1 min-w-[180px] w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Quarter <span className="text-red-500">*</span></label>
                            <select
                                value={selectedQuarter}
                                onChange={(e) => {
                                    setSelectedQuarter(e.target.value)
                                    localStorage.setItem('tdsQuarter', e.target.value)
                                }}
                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md"
                            >
                                <option value="">Select Quarter</option>
                                {quarterOptions.map(q => <option key={q} value={q}>{q}</option>)}
                            </select>
                        </div>

                        <div className="flex-1 min-w-[180px] w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Form Type <span className="text-red-500">*</span></label>
                            <select
                                value={selectedForm}
                                onChange={(e) => {
                                    const newForm = e.target.value;
                                    setSelectedForm(newForm)
                                    localStorage.setItem('tdsForm', newForm)
                                }}
                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md"
                            >
                                {formOptions.map(formVal => {
                                    const f = formVal;
                                    const actualForm = selectedFinancialYear && parseInt(selectedFinancialYear.split('-')[0]) >= 2026
                                        ? (f === '24Q' ? '138' : (f === '26Q' || f === '140') ? '140' : f === '27Q' ? '144' : f === '27EQ' ? '143' : f)
                                        : (f === '138' ? '24Q' : (f === '140' || f === '26Q') ? '26Q' : f === '144' ? '27Q' : f === '143' ? '27EQ' : f);
                                    return (
                                        <option key={formVal} value={actualForm}>
                                            {actualForm}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className="flex-1 min-w-[180px] w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-2">Return Type <span className="text-red-500">*</span></label>
                            <select
                                value={selectedReturnType}
                                onChange={(e) => {
                                    setSelectedReturnType(e.target.value)
                                    localStorage.setItem('SELECTED_RETURN_TYPE', e.target.value)
                                }}
                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md"
                            >
                                <option value="">Select Type</option>
                                <option value="Regular">Regular</option>
                                <option value="Correction">Correction</option>
                            </select>
                        </div>

                        {/* Premium Apply Selection and Conso Trigger */}
                        <div className="flex-1 min-w-[200px] w-full flex items-center mb-1">
                            <button
                                onClick={() => {
                                    const targetForm = selectedForm ? selectedForm.toLowerCase() : '27eq';
                                    const isCorrection = selectedReturnType === 'Correction';
                                    const suffix = isCorrection ? '-correction' : '';
                                    const targetPath = `/tds-dashboard/${targetForm}${suffix}`;
                                    if (location.pathname !== targetPath) {
                                        navigate(targetPath);
                                        toast.success('Selection Applied');
                                    } else {
                                        toast.success('Selection Applied');
                                    }
                                }}
                                className="w-full px-8 py-2.5 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg hover:from-orange-700 hover:to-red-700 transition-all font-semibold shadow-lg hover:shadow-orange-200"
                            >
                                Apply Selection
                            </button>
                        </div>
                    </div>
                </div>

                {/* Receipt Details Section (Conditional) */}
                {(selectedReturnType === 'Correction' || selectedReturnType === 'Regular') && (
                    <div className="bg-white rounded-xl shadow-md p-6 mb-8 border border-gray-100 overflow-hidden relative">
                        <div className="absolute top-0 left-0 w-2 h-full bg-orange-500"></div>
                        <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
                            <Building2 className="w-5 h-5 mr-2 text-orange-600" />
                            Statement Receipt Details <span className="text-red-500 ml-1">*</span>
                        </h3>

                        <div className="space-y-6">
                            {/* REVISED RETURN CASE - PREMIUM UI */}
                            {selectedReturnType === 'Correction' && (
                                <div className="bg-orange-50 rounded-xl p-6 border border-orange-100">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                                        {/* Conso Upload Area */}
                                        <div className="lg:col-span-1">
                                            <div className="flex flex-col items-center">
                                                <input
                                                    type="file"
                                                    accept=".tds"
                                                    onChange={handleConsoFileUpload}
                                                    className="hidden"
                                                    id="conso-upload-premium"
                                                />
                                                <label
                                                    htmlFor="conso-upload-premium"
                                                    className="group relative flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-orange-300 rounded-2xl bg-white hover:bg-orange-50 hover:border-orange-500 transition-all cursor-pointer overflow-hidden shadow-sm"
                                                >
                                                    {consoFileContent ? (
                                                        <motion.div initial={{ scale: 0.8 }} animate={{ scale: 1 }} className="flex flex-col items-center text-green-600">
                                                            <div className="bg-green-100 p-3 rounded-full mb-2">
                                                                <FileText className="w-8 h-8" />
                                                            </div>
                                                            <span className="text-sm font-bold">Conso File Ready</span>
                                                            <span className="text-xs text-green-500 mt-1">Click to Replace</span>
                                                        </motion.div>
                                                    ) : (
                                                        <div className="flex flex-col items-center text-gray-500">
                                                            <div className="bg-orange-100 p-3 rounded-full mb-3 group-hover:bg-orange-200 transition-colors">
                                                                <Upload className="w-8 h-8 text-orange-600" />
                                                            </div>
                                                            <span className="text-sm font-bold text-gray-700 group-hover:text-orange-700">Upload Conso File</span>
                                                            <span className="text-[10px] text-gray-400 mt-1 uppercase tracking-wider font-medium">Click to browse (.tds)</span>
                                                        </div>
                                                    )}

                                                    {/* Animated background glow */}
                                                    <div className="absolute inset-0 bg-blue-400 opacity-0 group-hover:opacity-5 transition-opacity pointer-events-none"></div>
                                                </label>

                                                <p className="mt-3 text-xs text-gray-500 text-center flex items-center">
                                                    <User className="w-3 h-3 mr-1" />
                                                    Upload Consolidated .tds file from TRACES
                                                </p>
                                            </div>
                                        </div>

                                        {/* Auto-filled Fields */}
                                        <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div className="space-y-2">
                                                <label className="text-xs font-bold text-orange-700 uppercase tracking-wider">
                                                    Receipt No. of Original Return
                                                </label>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        value={profileData?.section1?.receiptNoOriginal || ''}
                                                        disabled
                                                        className="w-full px-4 py-3 bg-white border border-orange-200 rounded-xl text-gray-700 font-medium shadow-sm cursor-not-allowed"
                                                        placeholder="Waiting for Conso upload..."
                                                    />
                                                    {profileData?.section1?.receiptNoOriginal && (
                                                        <div className="absolute right-3 top-1/2 -translate-y-1/2 bg-green-100 text-green-700 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                                            Verified
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="space-y-2">
                                                <label className="text-xs font-bold text-orange-700 uppercase tracking-wider">
                                                    Receipt No. of Earlier Statement
                                                </label>
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        value={profileData?.section1?.receiptNoEarlier || ''}
                                                        disabled
                                                        className="w-full px-4 py-3 bg-white border border-orange-200 rounded-xl text-gray-700 font-medium shadow-sm cursor-not-allowed"
                                                        placeholder="Waiting for Conso upload..."
                                                    />
                                                    {profileData?.section1?.receiptNoEarlier && (
                                                        <div className="absolute right-3 top-1/2 -translate-y-1/2 bg-green-100 text-green-700 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                                            Verified
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="md:col-span-2 flex items-center p-3 bg-white rounded-lg border border-orange-100 shadow-sm">
                                                <div className="bg-orange-100 p-2 rounded-lg mr-3">
                                                    <ArrowLeft className="w-4 h-4 text-orange-600" />
                                                </div>
                                                <p className="text-xs text-gray-600">
                                                    <span className="font-bold text-orange-600">Note:</span> These details are auto-extracted from your Conso file to ensure correctness and prevent validation failures.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ORIGINAL RETURN CASE */}
                            {selectedReturnType === 'Regular' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Is earlier Return Filed?
                                        </label>
                                        <select
                                            value={profileData?.section1?.isEarlierReturnFiled || 'No'}
                                            onChange={(e) => handleProfileInputChange('section1.isEarlierReturnFiled', e.target.value)}
                                            className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-900"
                                        >
                                            <option value="No">No</option>
                                            <option value="Yes">Yes</option>
                                        </select>
                                    </div>
                                    {profileData?.section1?.isEarlierReturnFiled === 'Yes' && (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Receipt No. of Original Return <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={profileData?.section1?.receiptNoOriginal || ''}
                                                onChange={(e) => handleProfileInputChange('section1.receiptNoOriginal', e.target.value)}
                                                required
                                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                                placeholder="Enter 15-digit Receipt Number"
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}


                <div className="bg-white rounded-lg shadow-lg border border-gray-200 min-h-[600px] flex flex-col">

                    {activeSection === 'tds-details' && (
                        <div className="p-4 flex-1">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-lg font-bold text-gray-800">TCS Details</h2>
                                {tdsData.length > 0 && (
                                    <span className="text-sm font-medium text-gray-600 bg-gray-100 px-3 py-1 rounded-full border border-gray-200">
                                        Total Records: {tdsData.length} | Total Tax: ₹{tdsData.reduce((sum, item) => sum + parseFloat(item.tdsAmount || 0), 0).toLocaleString('en-IN')}
                                    </span>
                                )}
                            </div>

                            <TdsDetailsTable
                                tdsData={tdsData}
                                challanData={challanData}
                                onTdsDataChange={handleTdsDataChange}
                                selectedFinancialYear={selectedFinancialYear}
                                selectedQuarter={selectedQuarter}
                                isRevised={selectedReturnType === 'Correction'}
                                originalData={originalTdsData}
                                sectionOptions={selectedFinancialYear && parseInt(selectedFinancialYear.split('-')[0]) >= 2026 ? collectionCodes27EQ_new : collectionCodes27EQ_old}
                                is27EQ={true}
                                collecteeOptions={collecteeCodes27EQ}
                            />
                        </div>
                    )}

                    {activeSection === 'challan-details' && (
                        <div className="p-4 flex-1">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-lg font-bold text-gray-800">Challan Details</h2>
                                {challanData.length > 0 && (
                                    <span className="text-sm font-medium text-gray-600 bg-gray-100 px-3 py-1 rounded-full border border-gray-200">
                                        Total Challans: {challanData.length} | Total Tax: ₹{challanData.reduce((sum, item) => sum + parseFloat(item.totalAmount || 0), 0).toLocaleString('en-IN')}
                                    </span>
                                )}
                            </div>

                            <ChallanDetailsTable
                                challanData={challanData}
                                tdsData={tdsData}
                                onChallanDataChange={handleChallanDataChange}
                                tan={profileData?.section1?.taxDeduction}
                                financialYear={selectedFinancialYear}
                                isRevised={selectedReturnType === 'Correction'}
                                sectionOptions={selectedFinancialYear && parseInt(selectedFinancialYear.split('-')[0]) >= 2026 ? collectionCodes27EQ_new : collectionCodes27EQ_old}
                            />
                        </div>
                    )}

                    {/* Disclaimer: Profile form not implemented in this snippet to save space, but data is preserved in state */}
                    {activeSection === 'profile' && (
                        <TdsProfileSection
                            profileData={profileData}
                            isProfileEditing={isProfileEditing}
                            onProfileDataChange={handleProfileInputChange}
                            onPrefillClick={() => setShowPrefillPrompt(true)}
                            selectedReturnType={selectedReturnType}
                        />
                    )}

                    {activeSection === 'generated-files' && (


                        <TdsGeneratedFiles isEmbedded={true} />


                    )}


                </div>

            </main>

            {/* Sidebar */}
            <TdsSidebar
                isOpen={sidebarOpen || (!isMobile && sidebarState.isOpen)}
                onClose={() => setSidebarOpen(false)}
                profileData={profileData}
                tdsData={tdsData}
                challanData={challanData}
                onSidebarStateChange={handleSidebarStateChange}
                errors={[]}
                activeSection={activeSection}
                onSectionChange={handleSectionChange}
                stateOptions={stateOptions}
                showCsiUpload={true}
                csiFile={csiFile}
                onCsiFileChange={(e) => setCsiFile(e.target.files[0])}
                isValidating={isValidating}
                onValidate={handlePrepareReturnFile}
                onCancelValidation={handleCancelValidation}
                isMobile={isMobile}
                selectionComplete={!!(selectedFinancialYear && selectedQuarter && selectedReturnType)}
            />

            {/* CSI Confirmation Modal */}
            {
                showCsiUploadPopup && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-2xl animate-fade-in border border-gray-100">
                            <h3 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">Upload CSI File</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">
                                To proceed with validation, you need to upload the <strong>Challan Status Inquiry (CSI)</strong> file.
                                <br /><br />
                                Please ensure you have downloaded it from the Income Tax portal.
                            </p>
                            <div className="flex justify-end space-x-4">
                                <button
                                    onClick={() => setShowCsiUploadPopup(false)}
                                    className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 font-medium transition-colors duration-200"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        setShowCsiUploadPopup(false)
                                        if (csiFileInputRef.current) {
                                            csiFileInputRef.current.value = ''
                                            csiFileInputRef.current.click()
                                        }
                                    }}
                                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium flex items-center transition-colors duration-200 shadow-md"
                                >
                                    <Upload className="w-4 h-4 mr-2" />
                                    Upload CSI File
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            <input
                type="file"
                ref={csiFileInputRef}
                style={{ display: 'none' }}
                accept=".csi"
                onChange={handleCsiFileChange}
            />

            {/* CSI Download Prompt Modal */}
            {
                showDownloadPrompt && (
                    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900 bg-opacity-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-all scale-100">
                            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                                <Upload className="w-5 h-5 mr-2 text-blue-600" />
                                Download CSI File
                            </h3>

                            <p className="text-gray-600 mb-4 text-sm">
                                Would you like to automatically download the latest CSI file from the Income Tax Portal?
                            </p>

                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Income Tax Password</label>
                                <div className="relative">
                                    <input
                                        type={showDownloadPassword ? "text" : "password"}
                                        className="w-full border border-gray-300 rounded-md p-2 pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                        value={downloadPassword}
                                        onChange={(e) => setDownloadPassword(e.target.value)}
                                        placeholder="Enter Password"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowDownloadPassword(!showDownloadPassword)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                                    >
                                        {showDownloadPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                                <p className="text-xs text-gray-500 mt-1">TAN: {profileData.section1.taxDeduction}</p>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={handleCsiDownload}
                                    disabled={isDownloadingCsi}
                                    className={`flex-1 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition flex items-center justify-center border border-transparent shadow-md ${isDownloadingCsi ? 'opacity-70 cursor-not-allowed' : ''}`}
                                >
                                    {isDownloadingCsi ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
                                            Downloading...
                                        </>
                                    ) : (
                                        <span className="font-medium">Download & Continue</span>
                                    )}
                                </button>
                                <button
                                    onClick={handleSkipDownload}
                                    disabled={isDownloadingCsi}
                                    className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 transition"
                                >
                                    Skip (I have file)
                                </button>
                            </div>
                            <button
                                onClick={() => setShowDownloadPrompt(false)}
                                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                )
            }

            {/* Validation Lock Screen Overlay */}
            {
                isValidating && (
                    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gray-900 bg-opacity-80 backdrop-blur-sm cursor-wait">
                        <div className="bg-white p-8 rounded-2xl shadow-2xl flex flex-col items-center max-w-lg text-center transform transition-all scale-100">
                            <div className="relative mb-6">
                                <div className="absolute inset-0 bg-orange-100 rounded-full animate-ping opacity-75"></div>
                                <div className="relative bg-white rounded-full p-2">
                                    <div className="animate-spin rounded-full h-16 w-16 border-4 border-orange-200 border-t-orange-600"></div>
                                </div>
                            </div>

                            <h3 className="text-2xl font-bold text-gray-800 mb-2">Validation in Progress</h3>
                            <p className="text-gray-600 mb-6">
                                Please wait while we validate your return.
                            </p>
                            <button
                                onClick={handleCancelValidation}
                                className="px-6 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 font-medium transition-colors border border-red-200"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )
            }



            {/* Profile Pre-fill Prompt Modal */}
            {
                showPrefillPrompt && (
                    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900 bg-opacity-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-all scale-100">
                            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                                <User className="w-5 h-5 mr-2 text-blue-600" />
                                Pre-fill Profile Data
                            </h3>

                            <p className="text-gray-600 mb-4 text-sm">
                                We will automatically extract your PAN, Email, Mobile and Address from the Income Tax Portal.
                            </p>

                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Income Tax Portal Password</label>
                                <div className="relative">
                                    <input
                                        type={showPrefillPassword ? "text" : "password"}
                                        className="w-full border border-gray-300 rounded-md p-2 pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                        value={prefillPassword}
                                        onChange={(e) => setPrefillPassword(e.target.value)}
                                        placeholder="Enter Portal Password"
                                        autoFocus
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPrefillPassword(!showPrefillPassword)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                                    >
                                        {showPrefillPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                                <p className="text-xs text-gray-500 mt-1">TAN: {profileData.section1.taxDeduction}</p>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={handleProfilePrefill}
                                    disabled={isExtractingProfile || !prefillPassword}
                                    className={`flex-1 bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition flex items-center justify-center border border-transparent shadow-md ${(isExtractingProfile || !prefillPassword) ? 'opacity-70 cursor-not-allowed' : ''}`}
                                >
                                    {isExtractingProfile ? (
                                        <>
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                            Get Data...
                                        </>
                                    ) : (
                                        <>
                                            <Upload className="w-4 h-4 mr-2" />
                                            Get Data
                                        </>
                                    )}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowPrefillPrompt(false);
                                        setPrefillPassword('');
                                    }}
                                    disabled={isExtractingProfile}
                                    className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 transition"
                                >
                                    Cancel
                                </button>
                            </div>
                            {!isExtractingProfile && (
                                <button
                                    onClick={() => setShowPrefillPrompt(false)}
                                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            )}
                        </div>
                    </div>
                )
            }
        </div >
    )
}

export default Tds27EQCorrectionForm
